import reflection from "@/assets/recovery-board/back-reflection.jpg";
import surprise from "@/assets/recovery-board/back-surprise.jpg";
import grounding from "@/assets/recovery-board/back-grounding.jpg";
import mystery from "@/assets/recovery-board/back-mystery.jpg";
import type { DeckId } from "@/data/recovery-board-cards";

/** Illustrated card backs: lotus (Reflect), gift (Surprise), stones (Grounding), crystal orb (Mystery). */
export const DECK_BACKS: Record<DeckId, string> = { reflection, surprise, grounding, mystery };
